<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Risk Management</h1>
              <img
                src="../../../public/assets/images/risk_manage_hi.png"
                class="title-section-img form-title-img risk-mgt-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">17.</span>Is a written pre-inspection agreement signed prior to each inspection?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="isPreInspectionAgreementAlwaysSigned"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="quote.isPreInspectionAgreementAlwaysSigned"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="isPreInspectionAgreementAlwaysSigned"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.isPreInspectionAgreementAlwaysSigned"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('isPreInspectionAgreementAlwaysSigned')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('isPreInspectionAgreementAlwaysSigned') | filterText }}</span>
                  </div>
              </div>
              <p>
                <i class="fas fa-exclamation-triangle not-eligible"></i>
                <span
                  class="not-eligible-text"
                >For the policy to respond, a signed pre-inspection agreement is required</span>
              </p>
              <p class="input-info pt-25">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>
                  Note: A signed Pre-Inspection Agreement is a Condition of Coverage.
                </span>
              </p>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">18.</span>What is the source of your inspection agreement?
              </label>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="preInspectionAgreementSource"
                    id="attorney"
                    value="attorney"
                    class="orep-radio"
                    v-validate="'required|included:attorney,training,prof,other'"
                    v-model="quote.preInspectionAgreementSource"
                    @change="validateBeforeSubmit()"
                  >
                  <span class="radio-span">Attorney</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="preInspectionAgreementSource"
                    id="prof"
                    value="prof"
                    class="orep-radio"
                    v-model="quote.preInspectionAgreementSource"
                    @change="validateBeforeSubmit()"
                  >
                  <span class="radio-span">Professional Association</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="preInspectionAgreementSource"
                    id="training"
                    value="training"
                    class="orep-radio"
                    v-model="quote.preInspectionAgreementSource"
                    @change="validateBeforeSubmit()"
                  >
                  <span class="radio-span">Training/School Franchisor</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="preInspectionAgreementSource"
                    value="other"
                    class="orep-radio"
                    v-model="quote.preInspectionAgreementSource"
                    @change="validateBeforeSubmit()"
                  >
                  <span class="radio-span">Other</span>
                </label>
              </div>
              <span
                v-show="errors.has('preInspectionAgreementSource')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('preInspectionAgreementSource') | filterText }}</span>
              <input
                type="text"
                name="preInspectionAgreementSourceOtherDetails"
                v-model="quote.preInspectionAgreementSourceOtherDetails"
                v-if="quote.preInspectionAgreementSource === 'other'"
                class="orep-text-input"
                placeholder="Other (please list)"
              >
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">19.</span>Does your pre-inspection agreement contain a limitation of liability clause?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="preInspectionAgreementHasLimitationOfLiabilityClause"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.preInspectionAgreementHasLimitationOfLiabilityClause"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="preInspectionAgreementHasLimitationOfLiabilityClause"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.preInspectionAgreementHasLimitationOfLiabilityClause"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('preInspectionAgreementHasLimitationOfLiabilityClause')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('preInspectionAgreementHasLimitationOfLiabilityClause') | filterText }}</span>
                </div>
                <p class="input-info pt-25">
                  <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                  <span>A limitation of liability in your agreement may lower your premium.</span>
                </p>

              </div>

              <p v-show="quote.preInspectionAgreementHasLimitationOfLiabilityClause === 'no'">
                <i class="fas fa-exclamation-triangle not-eligible"></i>
                <span
                  class="not-eligible-text"
                >A Limitation of liability clause can reduce your premium.</span>
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">20.</span>Do you take Digital Photos of your inspections?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="applicantTakesDigitalPhotosOfInspections"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.applicantTakesDigitalPhotosOfInspections"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantTakesDigitalPhotosOfInspections"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.applicantTakesDigitalPhotosOfInspections"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantTakesDigitalPhotosOfInspections')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantTakesDigitalPhotosOfInspections') | filterText }}</span>
                </div>
              </div>
              <div
                class="flex"
                v-if="quote.applicantTakesDigitalPhotosOfInspections === 'true' || quote.applicantTakesDigitalPhotosOfInspections == true"
              >
                <div class="col-md-9">
                  <p>
                    <i class="fas fa-exclamation-triangle not-eligible"></i>
                    <span class="not-eligible-text">
                      <span class="qtn mrpx-5">20 a.</span>Is there a method to authenticate the date and time the picture was taken?
                    </span>
                  </p>
                  <p>
                    <span class="not-eligible-text">
                      (Most phones and digital cameras automatically do this)
                    </span>
                  </p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isThereAMethodToAuthenticatePhotoDatetime"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.isThereAMethodToAuthenticatePhotoDatetime"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isThereAMethodToAuthenticatePhotoDatetime"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.isThereAMethodToAuthenticatePhotoDatetime"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('isThereAMethodToAuthenticatePhotoDatetime')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('isThereAMethodToAuthenticatePhotoDatetime') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">21.</span>
                Please list Inspection Standards/Standard of Practice the Applicant uses. (Examples: ASHI, CREIA, InterNACHI, HIF, HITA, and so on.)
              </label>
              <input
                type="text"
                class="orep-text-input"
                placeholder="List Applicant's Inspection Standards"
                name="listOfInspectionStandards"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="quote.listOfInspectionStandards"
              >
              <span
                v-show="errors.has('listOfInspectionStandards')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('listOfInspectionStandards') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">22.</span>Are You a Member of a Professional Association?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="professionalAssociationsApplicantBelongs"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.professionalAssociationsApplicantBelongs"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="professionalAssociationsApplicantBelongs"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.professionalAssociationsApplicantBelongs"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('professionalAssociationsApplicantBelongs')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('professionalAssociationsApplicantBelongs') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                placeholder="Please list any professional associations Applicant belongs to?"
                v-if="quote.professionalAssociationsApplicantBelongs === 'true' || quote.professionalAssociationsApplicantBelongs == true"
                name="listOfProfessionalAssociations"
                v-model="quote.listOfProfessionalAssociations"
              >
              <span
                v-show="errors.has('listOfProfessionalAssociations')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('listOfProfessionalAssociations') | filterText }}</span>
              <p class="input-info pt-25">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>Membership in a professional association can reduce your premium.</span>
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">23.</span>Does Applicant take continuing education and/or training yearly?
                    </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="applicantTakesContinuingTrainingYearly"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="quote.applicantTakesContinuingTrainingYearly"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="applicantTakesContinuingTrainingYearly"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="quote.applicantTakesContinuingTrainingYearly"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('applicantTakesContinuingTrainingYearly')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('applicantTakesContinuingTrainingYearly') | filterText }}</span>
                  </div>
                <p v-show="quote.applicantTakesContinuingTrainingYearly === 'false' || quote.applicantTakesContinuingTrainingYearly == false">
                  <i class="fas fa-exclamation-triangle not-eligible"></i>
                  <span
                    class="not-eligible-text"
                  >A continuing education program can reduce your premium.</span>
                </p>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">24.</span>Report Format: Is your Inspection Report Standardized?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isInspectionReportStandardized"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.isInspectionReportStandardized"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isInspectionReportStandardized"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.isInspectionReportStandardized"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('isInspectionReportStandardized')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('isInspectionReportStandardized') | filterText }}</span>
                </div>
              </div>
              <p></p>
              <span v-if="quote.isInspectionReportStandardized === 'true' || quote.isInspectionReportStandardized == true">
                <label class="orep-label">Please check all that apply</label>
                <div class="radio orep-radio-wrapper">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        class="orep-radio"
                        name="inspectionReportMode"
                        value="software"
                        v-model="quote.inspectionReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Software</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="inspectionReportMode"
                        value="paper/checklist"
                        class="orep-radio"
                        v-model="quote.inspectionReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Paper / Checklist</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="inspectionReportMode"
                        value="other"
                        class="orep-radio"
                        v-model="quote.inspectionReportMode"
                      >
                      <span class="radio-span solo-checkbox-span">Other</span>
                    </label>
                  </div>
                </div>
              </span>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">25.</span>Do you currently perform three or more home inspections per day on a regular basis, per inspector?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="averageOfMoreThan3InspectionsPerDayPerInspector"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.averageOfMoreThan3InspectionsPerDayPerInspector"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="averageOfMoreThan3InspectionsPerDayPerInspector"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.averageOfMoreThan3InspectionsPerDayPerInspector"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('averageOfMoreThan3InspectionsPerDayPerInspector')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('averageOfMoreThan3InspectionsPerDayPerInspector') | filterText }}</span>
                </div>
              </div>
              <label
                  class="orep-label pt-25"
                  v-if="quote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true' || quote.averageOfMoreThan3InspectionsPerDayPerInspector == true"
                >Please explain what processes and systems allow you to regularly perform three or more home inspections per day?</label>
              <input
                type="text"
                class="orep-text-input js-orep-input"
                v-if="quote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true' || quote.averageOfMoreThan3InspectionsPerDayPerInspector == true"
                name="moreThan3InspectionsDetails"
                v-model="quote.moreThan3InspectionsDetails"
              >
            </article>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Staff/Additional
                <br>Inspectors
              </h1>
              <img
                src="../../../public/assets/images/chess.png"
                class="title-section-img form-title-img zoom-risk-mgt-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <h4 class="inputs-table-title">
                <span class="qtn mrpx-5">26.</span>Please complete the following information:
              </h4>
              <div class="table-responsive hc-table inputs-table hc-small-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="th-left">Staff (Including yourself/Applicant)</th>
                      <th></th>
                      <th># Full Time</th>
                      <th></th>
                      <th># Part Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="td-res"># Home Inspectors</td>
                      <td></td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input table-text-input"
                          name="homeInspectorsFullTime"
                          v-validate="'required|numeric'"
                          @input="validateBeforeSubmit()"
                          v-model="quote.homeInspectorsFullTime"
                        >
                        <span
                          v-show="errors.has('homeInspectorsFullTime')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('homeInspectorsFullTime') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input table-text-input"
                          name="homeInspectorsPartTime"
                          v-validate="'required|numeric'"
                          @input="validateBeforeSubmit()"
                          v-model="quote.homeInspectorsPartTime"
                        >
                        <span
                          v-show="errors.has('homeInspectorsPartTime')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('homeInspectorsPartTime') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="td-res"># Non-Inspectors</td>
                      <td></td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input table-text-input"
                          name="nonInspectorsFullTime"
                          v-validate="'required|numeric'"
                          @input="validateBeforeSubmit()"
                          v-model="quote.nonInspectorsFullTime"
                        >
                        <span
                          v-show="errors.has('nonInspectorsFullTime')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nonInspectorsFullTime') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input table-text-input"
                          name="nonInspectorsPartTime"
                          v-validate="'required|numeric'"
                          @input="validateBeforeSubmit()"
                          v-model="quote.nonInspectorsPartTime"
                        >
                        <span
                          v-show="errors.has('nonInspectorsPartTime')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('nonInspectorsPartTime') | filterText }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">26 a.</span>Please list all home inspectors, including the principal / primary home inspector :
              </label>
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                placeholder="List all home inspectors, including the principal / primary home inspector."
                name="homeInspector1"
                v-model="quote.homeInspector1"
              >
              <span
                v-show="errors.has('homeInspector1')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('homeInspector1') | filterText }}</span>
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="homeInspector2"
                v-model="quote.homeInspector2"
              >
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="homeInspector3"
                v-model="quote.homeInspector3"
              >
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="homeInspector4"
                v-model="quote.homeInspector4"
              >
              <p class="input-info pt-25">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>Please list all home inspectors, including the principal / primary home inspector.</span>
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">27.</span>Do you use Independent Contractors?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouUseIndependentContractors"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="quote.doYouUseIndependentContractors"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouUseIndependentContractors"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.doYouUseIndependentContractors"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouUseIndependentContractors')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouUseIndependentContractors') | filterText }}</span>
                </div>
              </div>
              <div
                class="table-responsive hc-table inputs-table hc-small-table contractor-table"
                v-if="quote.doYouUseIndependentContractors === 'true' || quote.doYouUseIndependentContractors == true"
              >
                <p></p>
                <table class="table">
                  <thead>
                    <tr>
                      <th class="th-left">Independent Contractor Name
                        <br>(Please include additional names on a separate sheet)
                      </th>
                      <th></th>
                      <th>Does Inspector/IC have professional liability insurance coverage (E&O)?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="td-res">
                        <input
                          type="text"
                          class="orep-text-input table-text-input w-100"
                          placeholder="Independent Contractor Name"
                          name="contractor1Name"
                          v-validate="'required'"
                          @input="validateBeforeSubmit()"
                          v-model="quote.listOfIndependentContractorsToBeInsured.contractor1Name"
                        >
                        <span
                          v-show="errors.has('contractor1Name')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('contractor1Name') | filterText }}</span>
                      </td>
                      <td></td>
                      <td>
                        <div class="d-flex flex-row justify-content-center">
                          <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractor1Insured"
                              value="true"
                              class="orep-radio"
                              v-validate="'required'"
                              @change="validateBeforeSubmit()"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor1Insured"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                          <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractor1Insured"
                              value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor1Insured"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                        </div>
                        <span
                          v-show="errors.has('contractor1Insured')"
                          class="help is-danger form-errors text-danger"
                        >{{ errors.first('contractor1Insured') | filterText }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="td-res">
                        <input type="text" class="orep-text-input table-text-input w-100" v-model="quote.listOfIndependentContractorsToBeInsured.contractor2Name">
                      </td>
                      <td></td>
                      <td class="d-flex flex-row justify-content-center">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractorTwo"
                              value="true"
                              class="orep-radio"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor2Insured"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractorTwo"
                              value="false"
                              class="orep-radio"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor2Insured"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="td-res">
                        <input type="text" class="orep-text-input table-text-input w-100" v-model="quote.listOfIndependentContractorsToBeInsured.contractor3Name">
                      </td>
                      <td></td>
                      <td class="d-flex flex-row justify-content-center">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractorThree"
                              value="true"
                              class="orep-radio"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor3Insured"
                            >
                            <span class="radio-span">Yes</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="contractorThree"
                              value="false"
                              class="orep-radio"
                              v-model="quote.listOfIndependentContractorsToBeInsured.contractor3Insured"
                            >
                            <span class="radio-span">No</span>
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="table-p flex contractors-p pt-25">
                <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
                <span>Coverage for independent contractors applies ONLY to Work Completed for the Company Named in Line One. All independent contractors must use the inspection agreement of the named insured as a condition of coverage.</span>
              </p>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12 pr-0 pl-0">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">28.</span>Are all home inspectors/ICs licensed (in states where required)?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="areAllHomeInspectorsLicensedWhereStateRequires"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="quote.areAllHomeInspectorsLicensedWhereStateRequires"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="areAllHomeInspectorsLicensedWhereStateRequires"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="quote.areAllHomeInspectorsLicensedWhereStateRequires"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('areAllHomeInspectorsLicensedWhereStateRequires')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('areAllHomeInspectorsLicensedWhereStateRequires') | filterText }}</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-1'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button @click="prev()" class="pagination-dots"></button>
              <button class="pagination-dots pagination-current"></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid" @click="next('home-inspector-3')"></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid" @click="next('home-inspector-4')"></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid" @click="next('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid" @click="next('home-inspector-6')"></button>
              <button class="pagination-dots" :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid" @click="next('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
            </article>
            <button type="submit" :disabled="!state.pageTwoIsValid"
              :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="next('home-inspector-3')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "home-inspector-2",
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    state() {
      return this.$store.state.homeInspector;
    },
    errorMsg() {
      return this.$store.state.homeInspector.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "home-inspector-1"
      });
    },

    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
  },

  mounted() {
    function numberQtns(startNumber) {
      let numberOfQtns = document.querySelectorAll(".qtn");
      let i;

      for (i = 0; i < numberOfQtns.length; i++) {
        numberOfQtns[i].innerHTML = startNumber + ".";
        startNumber++;
      }
    }

    //numberQtns(27);

    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {}
};
</script>

